import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next';
import Modal from '../Modal'
import Tabs from '../Tabs/Tabs';
import { useTabs } from '../../Hooks/Tabs/useTabs';
import FileBoxRequestRequirementContainer from '../../Containers/FileBox/FileBoxRequestRequirementContainer';
import FileBoxUploadFileContainer from '../../Containers/FileBox/FileBoxUploadFileContainer';
import FileBoxTextsContainer from '../../Containers/FileBox/FileBoxTextsContainer';

function EditFileTransferModal({ onClose, t, editModalTab, selectedEvent }) {

    const tabs = [
        {
            id: 'texts',
            label: 'Texts',
            content: <FileBoxTextsContainer selectedEvent={selectedEvent}/>
        },
        {
            id: 'filerequest',
            label: 'File request requirements',
            content: <FileBoxRequestRequirementContainer selectedEvent={selectedEvent}/>
        },
        {
            id: 'uploadfiles',
            label: 'Upload files to customer',
            content: <FileBoxUploadFileContainer/>
        },
    ];

    const getInitialTab = () => {
        if (editModalTab) {
            const tab = tabs.find(t => t.id === editModalTab.name);
            return tab || tabs[0];
        }
        return tabs[0];
    };

    const { activeTab, setActiveTab } = useTabs(getInitialTab());

    const handleClickClose = () => {
        onClose();
    }

    const modal = {
        title: t('editfiletransfermodal.editfiletransfer'),
        hideMainButton: true,
        onCancelClick: handleClickClose,
        stateful: true,
        open: true,
        dialogStyle: { width: "60%" }
    }

    return (
        <Modal {...modal}>
            <div className='edit-file-transfer-container'>
                <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="tab-content p-32">
                    <div id="EventDiv">
                        {activeTab && activeTab.content}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EditFileTransferModal));